import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from "rxjs";
import {OrderedIdNameMxObj, ReportMxObj, TableMxObj} from "mx-core";

const REST_URL: string = '/rest';

@Injectable({
    providedIn: 'root'
})
export class PrlReportService {

    constructor(private httpClient: HttpClient) {
    }

    public getCampaignReports(campaignId: number, lang: string): Observable<OrderedIdNameMxObj[]> {
        let url = REST_URL + '/reports/campaign/' + campaignId;

        if (lang) {
            url = url + '/language/' + lang;
        }

        return this.httpClient.get<OrderedIdNameMxObj[]>(url);
    }

    public getAffiliateReports(lang: string): Observable<OrderedIdNameMxObj[]> {
        let url = REST_URL + '/reports/affiliate';

        if (lang) {
            url = url + '/language/' + lang;
        }

        return this.httpClient.get<OrderedIdNameMxObj[]>(url);
    }

    public getReportObj(campaignId: number, reportId: number, lang: string): Observable<ReportMxObj> {
        let url = REST_URL + '/reports/'
            + (campaignId !== null ? 'campaign/' + campaignId : 'affiliate')
            + '/report/' + reportId;

        if (lang) {
            url = url + '/language/' + lang;
        }

        return this.httpClient.get<ReportMxObj>(url);
    }

    public runReportAtOnce(reportAndSearchCriteria): Observable<TableMxObj> {
        let url = REST_URL + '/reports/run/at-once';
        return this.httpClient.post<TableMxObj>(url, reportAndSearchCriteria);
    }
}
